export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_01.d89d9392.jpg";